import { ListaService } from './../../../../_services/lista.service';
import { ProductoRestriccionActividadService } from './../../../../_services/producto-restriccion-actividad.service';
import { NavService } from './../../../../_services/_nav.service';
import { ProductosRestriccionesActividades } from './../../../../_models/producto-restriccion-actividad';
import { Producto } from './../../../../_models/producto';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-producto-restriccion-actividad',
  templateUrl: './producto-restriccion-actividad.component.html',
  styleUrls: ['./producto-restriccion-actividad.component.css'],
})
export class ProductoRestriccionActividadComponent implements OnInit {
  @Input() producto: Producto;
  @Input() verDetalle = false;

  cargando = true;
  guardando = false;
  submitted = false;
  columnas: any[] = [];
  formulario: FormGroup;

  lisTipoActividadLaboral: SelectItem[] = [];
  lisTipoActividadLaboralTodos: any[] = [];
  listaProductosRestriccionesActividades: ProductosRestriccionesActividades[] = [];
  listaProductosRestriccionesActividadesTodos: ProductosRestriccionesActividades[] = [];

  constructor(
    private fb: FormBuilder,
    private navServicio: NavService,
    private productoRestriccionActividadService: ProductoRestriccionActividadService,
    private lisService: ListaService
  ) {}

  ngOnInit() {
    this.cargaInicial();
  }

  cargaInicial() {
    this.lisTipoActividadLaboralTodos = [];
    this.lisTipoActividadLaboral = [];
    this.listaProductosRestriccionesActividades = [];
    this.listaProductosRestriccionesActividadesTodos = [];
    forkJoin(
      this.lisService.getMasterDetails('ListasActividadesLaborales'),
      this.productoRestriccionActividadService.listadoPorProducto(this.producto.idProducto)
    ).subscribe(([lisActividadesLaborales, listaProductosRestriccionesActividades]) => {
      this.lisTipoActividadLaboralTodos = lisActividadesLaborales;
      this.listaProductosRestriccionesActividadesTodos = listaProductosRestriccionesActividades;
      this.listaProductosRestriccionesActividades =
        this.listaProductosRestriccionesActividadesTodos.filter(
          (x) => x.indicadorHabilitado
        );
      this.validarLista();
      this.cargarFormulario();
      this.setearColumnas();
      this.cargando = false;
      this.guardando = false;
    });
  }

  /* validar y llenar las listas necesarias */
  validarLista() {
    this.lisTipoActividadLaboralTodos.map((x) => {
      if (
        !this.listaProductosRestriccionesActividades.find(
          (s) => s.idActividadLaboral === x.idLista
        )
      ) {
        this.lisTipoActividadLaboral.push({
          label: x.nombre,
          value: x.idLista,
        });
      }
    });
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idTipoActividad: [null, [Validators.required]]
    });
  }

  /* controls del formulario */
  get f() {
    return this.formulario.controls;
  }

  /* columnas del data table */
  setearColumnas() {
    this.columnas = [
      {
        field: 'tipo-actividad',
        header: this.navServicio.buscarMensaje(
          'PRODUCTORESTRICCIONES.LBL_TIPOACTIVIDAD'
        ),
        sort: false,
      },
      {
        field: 'acciones',
        header: this.navServicio.buscarMensaje('LBL_ACCIONES'),
        sort: false,
      },
    ];
  }

  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      this.guardarNivelRiesgoCliente();
    }
  }

  guardarNivelRiesgoCliente() {
    // Logica de guardado
    this.guardando = true;
    let registro: ProductosRestriccionesActividades = {} as ProductosRestriccionesActividades;
    const existe = this.listaProductosRestriccionesActividadesTodos.find((x) => x.idActividadLaboral === this.f.idTipoActividad.value);
    if (existe) {
      registro = existe;
      registro.idActividadLaboral = this.f.idTipoActividad.value;
      registro.indicadorHabilitado = true;
      this.productoRestriccionActividadService.actualizar(registro).subscribe(
        (res) => {
          this.navServicio.setMesage(1);
          this.formulario.reset();
          this.submitted = false;
          this.cargaInicial();
        },
        (error) => {
          this.navServicio.setMesage(3);
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
        }
      );
    } else {
      registro.idActividadLaboral = this.f.idTipoActividad.value;
      registro.idProducto = this.producto.idProducto;
      this.productoRestriccionActividadService.crear(registro).subscribe(
        (res) => {
          this.navServicio.setMesage(1);
          this.formulario.reset();
          this.submitted = false;
          this.cargaInicial();
        },
        (error) => {
          this.navServicio.setMesage(3);
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
        }
      );
    }

  }

  inhabilitarRegistro(row: ProductosRestriccionesActividades) {
    console.log(JSON.stringify(row));
    this.guardando = true;
    row.indicadorHabilitado = false;
    this.productoRestriccionActividadService.actualizar(row).subscribe(
      (res) => {
        this.navServicio.setMesage(2);
        this.formulario.reset();
        this.submitted = false;
        this.cargaInicial();
      },
      (error) => {
        this.navServicio.setMesage(3);
        this.formulario.reset();
        this.submitted = false;
        this.guardando = false;
      }
    );
  }
}
